import React, { useState } from 'react'
// import MISPreview from './components/MisPreview'
// import MISPages from './components/Pages'
import Page1MIS from './components/Page1'
import { useLocation } from 'react-router'
import { ToastContainer } from 'react-toastify'

const MISInput = () => {

    const location = useLocation();


    const [application, setApplication] = useState(location.state?.application || '');
    // const [year, setYear] = useState(location.state?.year || '');
    // If header and year are objects with { value, label }, extract their values
    const header = location.state?.header || '';
    const year = location.state?.year || '';
    // const header = typeof headerObj === 'object' && headerObj !== null ? headerObj.value : headerObj;
    // const year = typeof yearObj === 'object' && yearObj !== null ? yearObj.value : yearObj;

  return (


    <div className='page-wrapper p-3 mt-5'>
        {/* <MISPreview /> */}
        <Page1MIS 
        application={application}
        header={header}
        year={year}
        />
        {/* <PageMISExcel header={header} year={year} /> */}

      <ToastContainer position="top-right" autoClose={3000} />

    </div>
  )
}

export default MISInput